import { get } from '../utils/axios'

export const orgRoleAPI = async (orgid) => {
  const data = { orgId: orgid }
  return await get('orgs', data)
}

export const orgLevelIdAPI = async () => {
  return await get('org/levels')
}
